import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import {
  CDashboardApprenant,
  CDashboardClient,
  CDashboardIntervenant
} from '../../../../../../models/src/lib/dashboard/info-dashboard';
import 'moment/locale/fr';
import { MenuStoreService } from '@argalis-apps/angular-services';
import { AuthService } from '../../../auth/services/auth/auth.service';
import { MUser } from '@argalis-apps/models';
import { DemandeEncadrementService } from '../../services/demande-encadrement/demande-encadrement.service';

type listeTypeExtranet = CDashboardApprenant | CDashboardClient | CDashboardIntervenant;

@Component({
  selector: 'ags-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private userConnected: MUser.CUser = null;
  public activityCards = [];
  public shortcutButtons = [];
  public infoDashboard: listeTypeExtranet;
  public sessions = [];
  public dates = [];
  public nbNotifs: number;
  public indexDemandes: number;
  public loading = true;

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService,
    private menuStoreService: MenuStoreService,
    private demandeEncadrementService: DemandeEncadrementService
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });

    this.dashboardService.getInfoDashboard(this.userConnected).subscribe(
      (result: listeTypeExtranet[]) => {
        if (result.length) {
          this.infoDashboard = result[0];
          this.demandeEncadrementService
            // Récupérer le nombre de demandes d'encadrement
            .getListById(this.userConnected.userInfo.id)
            .subscribe(res => {
              this.infoDashboard.shortcuts.forEach(elem => {
                if (elem.title === "MES DEMANDES D'ENCADREMENT") {
                  elem.nbNotif = res.length || 0;
                }
                this.infoDashboard.cards.forEach(elem => {
                  if (elem.textButton === 'RÉPONDRE') {
                    elem.number = res.length || 0;
                  }
                });
              });
              this.loading = false;
            });
        }
      },
      () => {
        this.infoDashboard = null;
        this.loading = false;
      }
    );
  }

  ngOnInit() {
    this.getInfoDashboard();
  }

  getInfoDashboard() {}
}
